import React from 'react'
import useSound from 'use-sound'

import notification from '../../../static/notification.mp3'

const CountUnreadMessagesContext = React.createContext({})

const CountUnreadMessagesProvider = props => {
  const [unreadMessages, setUnreadMessages] = React.useState(0)
  const [play, { stop }] = useSound(notification)

  React.useEffect(() => {
    stop()
    if (unreadMessages) {
      play()
    }
  }, [unreadMessages])

  const value = React.useMemo(
    () => ({
      unreadMessages,
      setUnreadMessages,
    }),
    [unreadMessages],
  )

  return (
    <CountUnreadMessagesContext.Provider value={value}>
      {props.children}
    </CountUnreadMessagesContext.Provider>
  )
}

function useCountUnreadMessagesContext() {
  const context = React.useContext(CountUnreadMessagesContext)

  if (!context) {
    throw new Error(
      'useCountUnreadMessagesContext must be inside CountUnreadMessagesProvider',
    )
  }

  return context
}

export { CountUnreadMessagesProvider, useCountUnreadMessagesContext }
